import { formatLocalDateToIsoYmd, parseIsoYmdToLocalDate } from "helpers/date";
import useDocumentTitle from "hooks/useDocumentTitle";
import { sizer } from "layout/styles/styled/sizer";
import { Label } from "layout/typography/Label";
import { Button } from "primereact/button";
import { Calendar, CalendarValueType } from "primereact/calendar";
import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { FeeScheduleTable } from "./components/FeeScheduleTable";

const Container = styled.div`
  display: flex;
  align-items: end;
  flex-direction: column;
  overflow: hidden;
`;

const StyledButton = styled(Button)`
  gap: ${sizer(2)};
`;

export function FeeSchedulePage() {
  const navigate = useNavigate();
  useDocumentTitle("Fee schedule list");
  const [feeEffectiveDate, setFeeEffectiveDate] = useState<string | undefined>(
    undefined
  );

  return (
    <Container>
      <TabView className="w-full">
        <TabPanel header="Fee Schedule">
          <div className="flex flex-wrap justify-content-between align-items-end gap-3 mb-3 w-full">
            <div className="flex flex-column gap-2">
              <Label
                htmlFor="fee-schedule-page-effective-date"
                className="text-sm text-gray-700"
              >
                Fee effective date (optional)
              </Label>
              <Calendar
                inputId="fee-schedule-page-effective-date"
                value={
                  feeEffectiveDate
                    ? parseIsoYmdToLocalDate(feeEffectiveDate)
                    : null
                }
                onChange={(e: { value: CalendarValueType }) => {
                  const raw = e.value as Date | Date[] | null;
                  const d = Array.isArray(raw) ? raw[0] ?? null : raw;
                  setFeeEffectiveDate(
                    d ? formatLocalDateToIsoYmd(d) : undefined
                  );
                }}
                showIcon
                dateFormat="mm/dd/yy"
                placeholder="As of contract term"
                className="w-full md:w-14rem"
              />
            </div>
            <StyledButton
              icon="pi pi-plus"
              className="p-button-raised"
              onClick={() => navigate("/fee-schedule/new")}
            >
              New Fee Schedule
            </StyledButton>
          </div>

          <FeeScheduleTable feeEffectiveDate={feeEffectiveDate} />
        </TabPanel>
      </TabView>
    </Container>
  );
}
